module.exports = __webpack_public_path__ + "img/gif_low.9a1b2c25.gif";